module.exports = __webpack_public_path__ + "img/a63101681d6ca6dfd6d043ac5874e296.png";